import cx from 'classnames';
import { FC, useEffect, useState } from 'react';
import { TRecruitmentCharacterProfile, TRecruitmentGuildProfile, TRecruitmentTeamProfile } from '../../../libs/store';
import RecruitmentProfilePreview from '../../../shared/recruitment/components/RecruitmentProfilePreview/RecruitmentProfilePreview';
import Carousel, { CarouselItem } from '../Carousel';
import { Link } from '../../../../../../../shared/frontend/components/link';
import PatronLevel from '../../../../../../../shared/frontend/components/patreon/patronLevel';
import { Spinner } from '../../../../../../../shared/frontend/components/presentational/spinner';
import { TProfilesProps } from './shared';
import { getProfileTarget } from '../../../../../../../shared/frontend/scripts/recruitment/utils';

type TProfile = TRecruitmentCharacterProfile | TRecruitmentGuildProfile | TRecruitmentTeamProfile | null;

const FeaturedProfiles: FC<TProfilesProps> = (props) => {
  const { profiles } = props;
  const [currentSlide, setCurrentSlide] = useState<number>(0);
  const [currentProfile, setCurrentProfile] = useState<TProfile>(null);

  const handleChangeCurrentSlide = (currentItem: number) => {
    setCurrentSlide(currentItem);
  };

  useEffect(() => {
    const profile = profiles[currentSlide];
    if (profile) {
      setCurrentProfile(profile);
    }
  }, [profiles, currentSlide]);

  if (!currentProfile) {
    return (
      <div style={{ position: 'relative', margin: '0 auto' }}>
        <Spinner />
      </div>
    );
  }

  return (
    <div className="slds-grid slds-m-horizontal--auto">
      <Carousel onChangeItem={handleChangeCurrentSlide} width={400} autoScroll={6000}>
        {profiles.map((profile, index) => {
          const currentTarget = getProfileTarget(profile);
          const showPatronLevel = profile.patronLevel?.level;
          return (
            <CarouselItem key={index}>
              <Link
                to={`${currentTarget.path}/recruitment`}
                className="rio-no-style-type-link text-white"
                style={{ position: 'relative' }}
              >
                {showPatronLevel && (
                  <PatronLevel padForNonPatrons patronLevel={profile.patronLevel.level} absoluteOverlay />
                )}

                <RecruitmentProfilePreview
                  style={
                    showPatronLevel
                      ? {
                          padding: 3
                        }
                      : undefined
                  }
                  className={cx(
                    'carousel-item-content',
                    'rio-border-radius-xx-small',
                    'character-recruitment-preview--profile-border'
                  )}
                  profile={profile}
                  profileType={profile.entity_type}
                  target={{ details: currentTarget }}
                  useProfileTimezone={true}
                  hideAllTooltip={index !== currentSlide}
                  showPatronLabel
                />
              </Link>
            </CarouselItem>
          );
        })}
      </Carousel>
    </div>
  );
};

export default FeaturedProfiles;
